module.exports = __webpack_public_path__ + "assets/img/down.93945403.svg";